import {
  defFetchList,
  defFetchOne,
  defCreate,
  defUpdateOne,
  defUpdateStatus,
  defDeleteOne
} from '@/api/default'

const BASE_PATH = '/blog_country'

export function fetchList (query) {
  return defFetchList(BASE_PATH, query)
}

export function fetchOne (id) {
  return defFetchOne(BASE_PATH, id)
}

export function create (data) {
  return defCreate(BASE_PATH, data)
}

export function updateOne (id, data) {
  return defUpdateOne(BASE_PATH, id, data)
}

export function deleteOne (id) {
  return defDeleteOne(BASE_PATH, id)
}

export function updateStatus (id, data) {
  return defUpdateStatus(BASE_PATH, id, data)
}
